export default __webpack_public_path__ + "img/foipgWWL.db55a9df.svg";